import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Go to the `}<a parentName="p" {...{
        "href": "https://app.posthog.com/experiments"
      }}><strong parentName="a">{`Experiments`}</strong>{` tab`}</a>{` in the PostHog app and click on the `}<strong parentName="p">{`New experiment`}</strong>{` button in the top right.`}</p>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/create_experiment_ae83e877d6.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/create_experiment_dark_5c6a4acbd0.png" alt="Create experiment" classes="rounded" mdxType="ProductScreenshot" />
    <p>{`For this tutorial, let's create a new experiment using simplified test values: `}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Name`}</strong>{`: "Test experiment"`}</li>
      <li parentName="ul"><strong parentName="li">{`Description`}</strong>{`: "This is a test experiment"`}</li>
      <li parentName="ul"><strong parentName="li">{`Feature flag key`}</strong>{`: "test-experiment-ff-key"`}</li>
      <li parentName="ul"><strong parentName="li">{`Experiment type`}</strong>{`: "Feature flag"`}</li>
      <li parentName="ul"><strong parentName="li">{`Variants`}</strong>{`: "control" and "test"`}</li>
      <li parentName="ul"><strong parentName="li">{`Participant type`}</strong>{`: "Users"`}</li>
    </ul>
    <p>{`Then click `}<strong parentName="p">{`Save as draft`}</strong>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      